import { ValidationMethod } from '@/helpers/validation/Validator';
import i18n from '@/localization/localization';

// tslint:disable-next-line:variable-name
const string: ValidationMethod = (input, key = '') => {
    const check = typeof input === 'string' && Object.prototype.toString.call(input) === '[object String]';

    return {
        success: check,
        message: !check ? i18n.t('validation.validation_string', { key }).toString() : undefined,
    };
};

export default string;
